var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const EXPENSES_API = "api/expenses";
const EXPENSE_QUERY_PARAMS = [
    "storeId",
    "dateFrom",
    "dateTo",
    "category",
    "paymentMethod",
    // API-supported for future reporting/internal use; current POS expense UIs do not expose it.
    "hasCashierBoxMovement",
    "page",
    "limit",
];
const EXPENSE_EXPORT_QUERY_PARAMS = [
    "storeId",
    "dateFrom",
    "dateTo",
    "category",
    "paymentMethod",
    "hasCashierBoxMovement",
];
export const getList = function (storeId_1) {
    return __awaiter(this, arguments, void 0, function* (storeId, filters = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const query = generateQueryParamsStr(EXPENSE_QUERY_PARAMS, Object.assign({ storeId }, filters));
            return yield this.axiosInstance.get(`${EXPENSES_API}?${query}`, config);
        }
        catch (error) {
            console.error("Error fetching expenses getList:", error);
            throw error;
        }
    });
};
export const exportList = function (storeId_1) {
    return __awaiter(this, arguments, void 0, function* (storeId, filters = {}) {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "Content-disposition": "attachment; filename=[file.xlsx]",
                },
                responseType: "blob",
            };
            const query = generateQueryParamsStr(EXPENSE_EXPORT_QUERY_PARAMS, Object.assign({ storeId }, filters));
            return yield this.axiosInstance.get(`${EXPENSES_API}/export?${query}`, config);
        }
        catch (error) {
            console.error("Error fetching expenses exportList:", error);
            throw error;
        }
    });
};
export const getById = function (expenseId, storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const query = generateQueryParamsStr(["storeId"], { storeId });
            return yield this.axiosInstance.get(`${EXPENSES_API}/${expenseId}?${query}`, config);
        }
        catch (error) {
            console.error("Error fetching expenses getById:", error);
            throw error;
        }
    });
};
